import React from "react";
import { Auth0Context } from "@auth0/auth0-react";

const mockUser = {
  sub: "auth0|696e872fc47d2bf563947748",
  name: "Local Dev (cole.ewert@cortex.ag)",
  email: "cole.ewert@cortex.ag [dev]",
  /* eslint-disable-next-line camelcase */
  email_verified: true,
  "http://datapro.cortext.ag/role": "admin",
  "http://datapro.cortext.ag/client_id": null,
};

// Minimal shape matching what @auth0/auth0-react's context expects.
const mockContextValue = {
  isAuthenticated: true,
  isLoading: false,
  user: mockUser,
  error: undefined,
  /* eslint-disable @typescript-eslint/no-empty-function */
  loginWithRedirect: async () => {},
  loginWithPopup: async () => {},
  logout: async () => {},
  /* eslint-enable @typescript-eslint/no-empty-function */
  getAccessTokenSilently: async () => "",
  getAccessTokenWithPopup: async () => "",
  getIdTokenClaims: async () => undefined,
  handleRedirectCallback: async () => ({ appState: undefined }),
  buildAuthorizeUrl: async () => "",
  buildLogoutUrl: () => "",
};

interface Props {
  children: React.ReactNode;
}

export const MockAuth0Provider = ({ children }: Props): JSX.Element => {
  if (process.env.NODE_ENV === "production") {
    throw new Error("Auth bypass cannot be enabled in production.");
  }

  console.warn(
    "%c[LOCAL AUTH BYPASS ENABLED] REACT_APP_AUTH_BYPASS=true — Auth0 is not active. Do not use in staging or production.",
    "background: #ff8c00; color: #fff; font-weight: bold; padding: 4px 8px;"
  );

  return (
    <Auth0Context.Provider value={mockContextValue as any}>
      <div style={{
        position: "fixed", top: 0, left: 0, right: 0,
        zIndex: 99999, background: "#ff8c00", color: "#fff",
        textAlign: "center", fontSize: "0.7rem", fontWeight: "bold",
        letterSpacing: "0.1em", padding: "2px 0", pointerEvents: "none",
      }}>
        LOCAL AUTH BYPASS ENABLED
      </div>
      {children}
    </Auth0Context.Provider>
  );
};
